/** The two doors a platform admin can take (MVP-G2). Which one is open lives in
 *  `portal-context.tsx`, for the page load only; the API decides what they may see. */
export type Portal = "org" | "admin";

/** The only e-mail domain whose people can be platform admins. Mirrors
 *  `domain::PLATFORM_ADMIN_DOMAIN`; the server enforces it, this only decides what to draw. */
const PLATFORM_ADMIN_DOMAIN = "humindly.io";

/**
 * Whether the signed-in person is a platform admin, read from the ID token itself —
 * synchronously, before anything is drawn, with no request in between. The picker is a
 * question only these people are ever asked; for everyone else this is false on the first
 * render and stays false. A malformed or foreign token is simply "no".
 */
export function isPlatformAdminToken(idToken: string | null | undefined): boolean {
  if (!idToken) return false;
  try {
    const part = idToken.split(".")[1];
    if (!part) return false;
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/").padEnd(part.length + ((4 - (part.length % 4)) % 4), "="));
    const claims = JSON.parse(json) as { "cognito:groups"?: unknown; email?: unknown };
    const groups = Array.isArray(claims["cognito:groups"]) ? (claims["cognito:groups"] as unknown[]) : [];
    if (!groups.includes("platform_admin")) return false;
    const email = typeof claims.email === "string" ? claims.email.trim() : "";
    const at = email.lastIndexOf("@");
    if (at <= 0) return false;
    return email.slice(at + 1).toLowerCase() === PLATFORM_ADMIN_DOMAIN;
  } catch {
    return false;
  }
}
